import React from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslate } from 'react-admin'
import { Box, Typography, useTheme } from '@mui/material'

// Password policy of the Cognito user pool: 12+ characters with lowercase,
// uppercase, digit and symbol (symbols are the ones Cognito accepts as
// special characters). Shared by user creation and the account page.
export const passwordRules = [
    { key: 'min_length', test: (value) => value.length >= 12 },
    { key: 'lowercase', test: (value) => /[a-z]/.test(value) },
    { key: 'uppercase', test: (value) => /[A-Z]/.test(value) },
    { key: 'digit', test: (value) => /[0-9]/.test(value) },
    { key: 'symbol', test: (value) => /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]/.test(value) },
]

// react-admin validator: every rule must pass
export const passwordPolicy = (value) =>
    passwordRules.every(rule => rule.test(value || '')) ? undefined : 'resources.users.password_invalid'

// react-admin validator factory: the field must equal `otherField`
export const passwordsMatch = (otherField = 'password') => (value, allValues) =>
    value === allValues[otherField] ? undefined : 'resources.users.passwords_differ'

// live checklist of the rules, driven by the value of `source`
export const PasswordPolicyHint = ({ source }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const value = useWatch({ name: source }) || '';
    const lineStyle = { fontFamily: "Roboto", fontSize: "12px", fontWeight: 400, lineHeight: "18px" }
    const validColor = theme.palette.mode === 'light' ? '#2e7d32' : '#66bb6a'
    return (
        <Box>
            <Typography color="text.main" sx={lineStyle}>
                {translate('resources.users.password_policy.title')}
            </Typography>
            {passwordRules.map(rule => {
                const valid = rule.test(value)
                return (
                    <Typography
                        key={rule.key}
                        sx={{ ...lineStyle, fontWeight: valid ? 500 : 400, color: valid ? validColor : theme.palette.text.secondary }}
                    >
                        {valid ? '✓' : '•'} {translate(`resources.users.password_policy.${rule.key}`)}
                    </Typography>
                )
            })}
        </Box>
    )
}
